import { createFileRoute } from "@tanstack/react-router";
import { requerirEdicionDeSolicitud } from "@/features/solicitudes/utils/guard-edicion";
import { cecosQueryOptions, cuentasQueryOptions } from "@/features/catalogos/hooks/use-catalogos";
import { ProrrateoPage } from "@/features/prorrateo/components/ProrrateoPage";
import { prorrateoQueryOptions } from "@/features/prorrateo/hooks/use-prorrateo";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert, WizardPasoSkeleton } from "@/components/ui";

/**
 * Ruta `/solicitudes/$id/prorrateo` · file delgado.
 *
 * El `loader` precarga todos los datos que ProrrateoPage consume con
 * `useSuspenseQuery` · cuando el componente monta, su árbol nunca
 * está en estado loading (cero flicker en navegación).
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/prorrateo")({
  beforeLoad: requerirEdicionDeSolicitud,
  loader: ({ context: { queryClient }, params: { id } }) =>
    Promise.all([
      queryClient.ensureQueryData(prorrateoQueryOptions(id)),
      queryClient.ensureQueryData(solicitudQueryOptions(id)),
      queryClient.ensureQueryData(cecosQueryOptions),
      queryClient.ensureQueryData(cuentasQueryOptions),
    ]),
  component: ProrrateoPage,
  pendingComponent: WizardPasoSkeleton,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
